(function(){
"use strict";

angular.module("swapick")
.factory('Purchase', Purchase);

function Purchase($q, DataService, $rootScope, $ionicPlatform){
  var svc = {}
  console.log("window.store", window.store);
    svc.products = [];
    svc.initialized = false;

    svc.setup = () => {
      return $ionicPlatform.ready(svc._setup)

    }

    svc.setup = () => {
        console.log("setup store called...")
        let out = $q.defer();

        let cb = store.ready(()=>{
          console.log("store ready");
          svc.products = store.products;
          $rootScope.PURCHASE_PRODUCTS = svc.products;
          $rootScope.$broadcast("PURCHASE_PRODUCTS_UPDATE", svc.products);
          console.log("store ready - rootscope broadscasted");
          store.off(cb);
          out.resolve(store.products);
        });

        store.verbosity = store.INFO;
        svc.initialized = true;

        DataService.services
        .getList()
        .then(items => {
          let newItems = _.filter(items, i=> i.pagamento == 'in-app');
          _.each(newItems, product => {
            let x = store.register({
                id:    product.id.toString(),
                alias: product.name,
                type:  store.CONSUMABLE
            });
          })

          store.refresh();
        })

        return out.promise;

    }


  svc.orderProduct  = (product, promiseMaker) => {
    let out = $q.defer();
    store.when(product.id).approved(product => {
      // download the feature
      return promiseMaker(product)
      .then(() => {
        product.finish();
        out.resolve(product);
      });
    });

    store.when(product.id).cancelled(() => {
      // download the feature
      out.reject(null);
    });

    store.when(product.id).error(err => {
      // download the feature
      out.reject(err);
    });

    store.order(product.id);
    return out.promise;
  }


  return svc;
}



})();



// WEBPACK FOOTER //
// ./src/services/purchase-service.js